import { InfoCard } from './info-card'
import { InfoSection } from './info-section'
import { SectionHeading } from './info-section-heading'

function PosUnsubscribedCard() {
  return (
    <InfoCard>
      <InfoSection>
        <SectionHeading>POS Status:</SectionHeading>
        <div className="text-ion-color-danger">Unsubscribed</div>
      </InfoSection>
    </InfoCard>
  )
}

export { PosUnsubscribedCard }
